export const SENTRY_ENABLED =
  process.env.NODE_ENV === "production" &&
  process.env.NEXT_PUBLIC_VERCEL_ENV === "production";

export const SENTRY_TRACES_SAMPLE_RATE = 0.03;
